"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _range2 = _interopRequireDefault(require("lodash/range"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _defaults2 = _interopRequireDefault(require("lodash/defaults"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _InfiniteScroll = _interopRequireDefault(require("../list/InfiniteScroll"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uuid = _interopRequireDefault(require("uuid"));

var _PropUtils = require("../../util/PropUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var Head = function Head(_ref) {
  var columnOrder = _ref.columnOrder,
      dataId = _ref["data-id"],
      fixed = _ref.fixed,
      getDropClass = _ref.getDropClass,
      headContentType = _ref.headContentType,
      headData = _ref.headData,
      onCancel = _ref.onCancel,
      onDrag = _ref.onDrag,
      onDrop = _ref.onDrop,
      widths = _ref.widths,
      _ref$renderHeaderCell = _ref.renderHeaderCell,
      renderHeaderCell = _ref$renderHeaderCell === void 0 ? _PropUtils.defaultRender : _ref$renderHeaderCell;
  var suffixedId = fixed ? dataId + "-fixedHead" : dataId + "-Head";
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": suffixedId,
    className: (0, _classnames.default)("thead", fixed && "fixed")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tr",
    role: "row"
  }, (0, _map.default)(columnOrder).call(columnOrder, function (headIndex, index) {
    var _headData$headIndex$c = headData[headIndex].content,
        content = _headData$headIndex$c === void 0 ? headData[headIndex] : _headData$headIndex$c;
    var style = widths ? {
      minWidth: widths[headIndex],
      maxWidth: widths[headIndex]
    } : null;
    var className = (0, _classnames.default)(getDropClass(content, index), "th");
    return renderHeaderCell({
      key: index,
      "data-id": "header_".concat(content),
      id: index,
      index: index,
      onDrag: onDrag,
      style: style,
      type: "column",
      className: className,
      onDrop: onDrop,
      onCancel: onCancel,
      role: "columnheader",
      children: headContentType ? /*#__PURE__*/_react.default.cloneElement(headContentType, (0, _defaults2.default)({
        id: headIndex,
        key: headIndex,
        index: headIndex,
        data: content
      })) : content
    }, "div");
  })));
};

var Body = function Body(_ref2) {
  var beingDragged = _ref2.beingDragged,
      bodyClassName = _ref2.bodyClassName,
      bodyData = _ref2.bodyData,
      columnOrder = _ref2.columnOrder,
      dataId = _ref2["data-id"],
      getDropClass = _ref2.getDropClass,
      widths = _ref2.widths;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: (0, _classnames.default)(bodyClassName, "tbody")
  }, (0, _map.default)(bodyData).call(bodyData, function (row, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tr",
      key: index
    }, (0, _map.default)(columnOrder).call(columnOrder, function (columnIndex, dataIndex) {
      var dragClass = beingDragged === dataIndex ? "dragging" : null;
      var style = widths ? {
        minWidth: widths[columnIndex],
        maxWidth: widths[columnIndex]
      } : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(getDropClass(row[columnIndex], dataIndex), dragClass, "td"),
        style: style,
        key: columnIndex
      }, row[columnIndex]);
    }));
  }));
};

var ISBody = function ISBody(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": props["data-id"],
    className: (0, _classnames.default)(props.bodyClassName, "infinite-scroll-wrapper")
  }, /*#__PURE__*/_react.default.createElement(_InfiniteScroll.default, (0, _extends2.default)({}, props.infiniteScroll, {
    contentType: /*#__PURE__*/_react.default.createElement(ISRow, props),
    onScroll: props.onISScroll,
    batches: props.infiniteScroll.batches || [{
      id: 1,
      data: props.bodyData
    }]
  })));
};

var ISRow = function ISRow(props) {
  var _context;

  return /*#__PURE__*/_react.default.createElement("div", null, (0, _map.default)(_context = props.columnOrder).call(_context, function (columnIndex, dataIndex) {
    var dragClass = props.beingDragged === dataIndex ? "dragging" : null;
    var style = props.widths ? {
      minWidth: props.widths[columnIndex],
      maxWidth: props.widths[columnIndex]
    } : null;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: _uuid.default.v4(),
      className: (0, _classnames.default)(props.getDropClass(props[columnIndex], dataIndex), "td", dragClass),
      style: style
    }, props[columnIndex]);
  }));
};
/**
 * @callback ReportTable~onDrag
 * @param {number} targetIndex
 *          current target index where items is dragged over or dropped
 * @param {number} sourceIndex
 *          origin index item is dragged or dropped from
 */

/**
 * @callback ReportTable~onDrop
 * @param {number} targetIndex
 *          current target index where items is dragged over or dropped
 * @param {number} sourceIndex
 *          origin index item is dragged or dropped from
 */

/**
 * @callback ReportTable~onCancel
 */

/**
 * @class ReportTable
 *
 * @desc A stateless wrapper for the DragDrop component that provides table markup based on data
 *
 * @param {DragDrop~onDrag} onDrag
 *          A callback which is execute when the row is moved.  Must have signature function (targetIndex, ownIndex)
 * @param {DragDrop~onDrop} onDrop
 *          A callback which is execute when the row is dropped.  Must have signature function (targetIndex, ownIndex)
 * @param {DragDrop~onCancel} onCancel
 *          A callback which is executed when the dragging is cancelled (dropped outside a droppable area
 *          or esc button pressed).
 *
 * @param {array} headData
 *          An array of values for the table head. Members of array can either be strings or objects with
 *          properties of width (number) and content (string)
 * @param {array} [bodyData]
 *          An array of arrays for the body that are ordered in the same was as the headData
 * @param {array} [columnOrder]
 *          An array of values to represent the order of the columns
 * @param {object} [headContentType]
 *          A React object that can be used as a wrapper for the th elements. Receives id, key, index and data as props.
 * @param {string} [className="report-table"]
 *          Classname for the parent table
 * @param {number} [beingDragged]
 *          Index in the headData array that corresponds with the dragging item
 * @param {number} [dropTarget]
 *          Index in the headData array that corresponds with the item drop zone
 * @param {boolean} [fixedHead=true]
 *          Fixes the table header for vertical scrolling
 * @param {object} [infiniteScroll]
 *          Props to pass to the InfiniteScroll component. If included InfiniteScroll is automatically enabled.
 *
 * @example
 *
 * <ReportTable
 *      data-id = "my-report-table"
 *      headData={this.state.headings}
 *      columnOrder={this.state.order}
 *      headContentType={this._getHeadContentType()}
 *      bodyData={this.state.rows}
 *      beingDragged={this.state.beingDragged}
 *      dropTarget={this.state.dropTarget}
 *      onDrag={this._onDrag}
 *      onDrop={this._onDrop}
 *      onCancel={this._onCancel} />
 *
 */


var ReportTable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ReportTable, _React$Component);

  var _super = _createSuper(ReportTable);

  function ReportTable() {
    var _context2;

    var _this;

    (0, _classCallCheck2.default)(this, ReportTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context2 = [this]).call(_context2, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      columnWidths: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_setWidths", function () {
      var _context3;

      var headerTh = _this.tableHead.getElementsByClassName("th");

      _this.setState({
        columnWidths: (0, _map.default)(_context3 = _this.props.headData).call(_context3, function (_ref3, idx) {
          var width = _ref3.width;
          return width !== undefined ? width : headerTh[idx].getBoundingClientRect().width;
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleHorizontalScroll", function (_ref4) {
      var scrollLeft = _ref4.currentTarget.scrollLeft;

      if (_this.initialX === scrollLeft) {
        return;
      }

      _this.tableHead.style.left = -scrollLeft + "px";
      _this.initialX = scrollLeft;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleISHorizontalScroll", function (param, e) {
      _this._handleHorizontalScroll(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_infiniteScrollRef", function (component) {
      _this.infiniteScrollNode = _reactDom.default.findDOMNode(component);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getDropClass", function (item, index) {
      var dragRight = _this.props.headData.length - 1 === index && _this.props.dropTarget === _this.props.headData.length;
      return (0, _classnames.default)("dd-column", {
        "drag-left": _this.props.dropTarget === index
      }, {
        "drag-right": dragRight
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ReportTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tableHead = _reactDom.default.findDOMNode(this.rootElement.getElementsByClassName("thead")[0]);

      if (this.props.fixedHead && !this.state.columnWidths) {
        this._setWidths();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.fixedHead && !(0, _isEqual2.default)(prevProps.headData, this.props.headData)) {
        this._setWidths();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _context4,
          _this2 = this;

      var order = this.props.columnOrder || (0, _map.default)(_context4 = (0, _range2.default)(this.props.headData.length)).call(_context4, Number.call, Number);
      var bodyData = this.props.infiniteScroll ? this.props.infiniteScroll.batches[0].data || this.props.bodyData : this.props.bodyData;
      var infiniteScrollActive = this.props.infiniteScroll && this.state.columnWidths;
      var fixedHeadActive = (this.props.fixedHead || this.props.infiniteScroll) && this.state.columnWidths;
      var props = (0, _defaults2.default)({
        columnOrder: order,
        getDropClass: this._getDropClass,
        widths: this.state.columnWidths,
        fixed: fixedHeadActive,
        bodyData: bodyData,
        onISScroll: infiniteScrollActive ? this._handleISHorizontalScroll : null
      }, this.props);
      var onScroll = fixedHeadActive && !infiniteScrollActive ? this._handleHorizontalScroll : null;

      if (this.props.infiniteScroll) {
        this.props.infiniteScroll.ref = this._infiniteScrollRef;
      }

      var tableHead = /*#__PURE__*/_react.default.createElement(Head, props);

      var tableBody = this.props.infiniteScroll && this.state.columnWidths ? /*#__PURE__*/_react.default.createElement(ISBody, (0, _extends2.default)({}, props, {
        "data-id": "".concat(props["data-id"], "-body")
      })) : /*#__PURE__*/_react.default.createElement(Body, (0, _extends2.default)({}, props, {
        "data-id": "".concat(props["data-id"], "-body")
      }));
      var className = (0, _classnames.default)(this.props.className, {
        "infinite-scroll-container": infiniteScrollActive
      }, {
        "fixed-head": fixedHeadActive
      }, {
        "has-next": infiniteScrollActive && this.props.infiniteScroll.hasNext
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: className,
        ref: function ref(_ref5) {
          return _this2.rootElement = _ref5;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "dd-table-container",
        onScroll: onScroll,
        "data-id": this.props["data-id"] + "-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "table",
        role: "table",
        "data-id": this.props["data-id"] + "-table"
      }, tableHead, tableBody)));
    }
  }]);
  return ReportTable;
}(_react.default.Component);

(0, _defineProperty2.default)(ReportTable, "propTypes", {
  "data-id": _propTypes.default.string,
  onDrag: _propTypes.default.func,
  onDrop: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  headData: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.shape({
    content: _propTypes.default.string,
    width: _propTypes.default.number
  }), _propTypes.default.string])).isRequired,
  bodyData: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.node)),
  columnOrder: _propTypes.default.array,
  headContentType: _propTypes.default.object,
  className: _propTypes.default.string,
  beingDragged: _propTypes.default.number,
  dropTarget: _propTypes.default.number,
  fixedHead: _propTypes.default.bool,
  infiniteScroll: _propTypes.default.object,
  renderHeaderCell: _propTypes.default.func
});
(0, _defineProperty2.default)(ReportTable, "defaultProps", {
  "data-id": "report-table",
  className: "report-table",
  fixedHead: false
});
module.exports = ReportTable;